import {
  currencyToTargetCurrency,
} from '../../../../utils/common';
/**
 * @description 精度
 */
export const PRECISION = 2
/**
 * @description 仓储费
 */
export function getStorageCost(that) {
  that.form.storageCost = (that.form.salePrice * that.form.storageFeeRate) / 100;
  that.form.storageCost = +that.form.storageCost.toFixed(PRECISION)
}
/**
 * @description 渠道佣金
 */
export function getCommission(that) {
  that.form.commission = (that.form.salePrice * that.form.channelCommissionRate) / 100;
  that.form.commission = +that.form.commission.toFixed(PRECISION)
}
/**
 * @description 目标渠道配送费
 */
export function getResultChannelsCommission(that) {
  that.form.resultChannelsCommission =
    that.form.fulfillment === 'FBM'
      ? currencyToTargetCurrency(
        that.form.fbmCost,
        that.form.fbmCostSymbol,
        that.form.currency,
        that.exchangeRateMap,
      )
      : +that.form.trialWarehouseFee;
      that.form.resultChannelsCommission = +that.form.resultChannelsCommission.toFixed(PRECISION)
}
/**
 * @description 广告费用
 */
export function getAdType(that) {
  that.form.adCost =
    that.form.adType === 'percentage'
      ? (that.form.adsFeeRate * that.form.salePrice) / 100
      : currencyToTargetCurrency(
        that.form.adsFeeRate,
        that.form.adType,
        that.form.currency,
        that.exchangeRateMap,
      );
      that.form.adCost = +that.form.adCost.toFixed(PRECISION)
}

/**
 * @description 退款费
 */
export function getRefundCommission(that) {
  that.form.refundCommission = (that.form.refundFeeRate * that.form.salePrice) / 100;
  that.form.refundCommission = +that.form.refundCommission.toFixed(PRECISION)
}
/**
 * @description 销售VAT税费
 */
export function getVATcommission(that) {
  that.form.VATcommission = that.form.includeTax
    ? ((that.form.salePrice / (1 + that.form.sellVatFee / 100)) * that.form.sellVatFee) / 100
    : (that.form.salePrice * that.form.sellVatFee) / 100;
    that.form.VATcommission = +that.form.VATcommission.toFixed(PRECISION)
}
/**
 * @description 其他费用最终值
 */
export function getOtherCostValue(that) {
  that.form.otherFeeValue =
    that.form.otherFeeSymbol === 'percentage'
      ? (that.form.otherFee * +that.form.salePrice) / 100
      : currencyToTargetCurrency(
        that.form.otherFee,
        that.form.otherFeeSymbol,
        that.form.currency,
        that.exchangeRateMap,
      );
      that.form.otherFeeValue = +that.form.otherFeeValue.toFixed(PRECISION)
}

/**
 * @description 关税
 */
export function geTtariff(that) {
  that.form.tariff =
    (that.form.reportValueRate *
      currencyToTargetCurrency(
        that.form.purchaseCost,
        that.form.purchaseCostSymbol,
        that.form.currency,
        that.exchangeRateMap,
      ) *
      that.form.tariffFeeRate) /
    10000;
    that.form.tariff = +that.form.tariff.toFixed(PRECISION)
}

/**
 * @description 非平台费合计
 */
export function getOthertotalCost(that) {
  that.form.othertotalCost = that.form.otherFeeValue + that.form.tariff;
  that.form.othertotalCost = +that.form.othertotalCost.toFixed(PRECISION)
}

/**
 * @description 总成本
 */
export function getTotalCost(that) {
  that.form.totalCost =
    currencyToTargetCurrency(
      that.form.arrivalCost,
      that.form.inventoryCostSymbol,
      that.form.currency,
      that.exchangeRateMap,
    ) +
    currencyToTargetCurrency(
      that.form.purchaseCost,
      that.form.purchaseCostSymbol,
      that.form.currency,
      that.exchangeRateMap,
    )
    that.form.totalCost = +that.form.totalCost.toFixed(PRECISION)
}
/**
 * @description 平台总费用
 */
export function getPlatformCost(that) {
  that.form.platformCost =
    that.form.storageCost +
    that.form.commission +
    that.form.resultChannelsCommission +
    that.form.adCost +
    that.form.refundCommission +
    that.form.VATcommission;
    that.form.platformCost = +that.form.platformCost.toFixed(PRECISION)
}

/**
 * @description 计算售价
 */
//  仓储费占比+渠道佣金占比+广告花费占比+退款率+ VAT税率+
//  其他费用占比+毛利润率
export function getSellPrice(that) {
  getResultChannelsCommission(that)
  let numberVlaue = that.form.totalCost + that.form.tariff + that.form.resultChannelsCommission,
    rateValue =
      100 -
      that.form.storageFeeRate -
      that.form.channelCommissionRate -
      that.form.refundFeeRate -
      that.form.profitRate,
    LIST = [
      { flag: 'adType', value: 'adCost', percentage: 'adsFeeRate' },
      { flag: 'otherFeeSymbol', value: 'otherFeeValue', percentage: "otherFee" },
    ];
  for (let { flag, value, percentage } of LIST) {
    if (that.form[flag] === 'percentage') {
      rateValue -= that.form[percentage];
    } else {
      numberVlaue += that.form[value];
    }
  }
  if (that.form.includeTax) rateValue -= that.form.sellVatFee;
  if (rateValue <= 0) {
    that.$message({
      message: '仓储费占比+渠道佣金占比+广告花费占比+退款率+ VAT税率+其他费用占比+毛利润率不得高于100%，否则无法进行计算',
      type: 'warning'
    });
  } else {
    that.form.salePrice = rateValue == 0 ? 0 : (numberVlaue / rateValue * 100).toFixed(PRECISION);
  }
}

/**
 * @description 计算利润
 */
export function getProfit(that) {
  let value = that.form.salePrice - that.form.totalCost - that.form.platformCost - that.form.othertotalCost
  that.form.profit = (that.form.includeTax ? value : value + that.form.VATcommission).toFixed(PRECISION)
}
/**
 * @description 计算利润率
 */
export function getProfitRate(that) {

  that.form.profitRate = that.form.salePrice == 0 ? 0 : (that.form.profit / that.form.salePrice * 100).toFixed(PRECISION)
}
/**
 * @description 计算成本利润
 */
export function getTotalCostRate(that) {
  that.form.costRate = that.form.totalCost === 0 ? 0 : (that.form.profit / that.form.totalCost * 100).toFixed(PRECISION)
}
/**
 * @description 初始化需要计算的值
 */
export const INITMETHODS = [
  getStorageCost,
  getCommission,
  getResultChannelsCommission,
  getAdType,
  getRefundCommission,
  getVATcommission,
  geTtariff,
  getOtherCostValue,
  getOthertotalCost,
  getTotalCost,
  getPlatformCost,
  getProfit,
  getProfitRate,
  getTotalCostRate
];

/**
 * @description 只要输入框发生变化就需要处理的逻辑
 */
export function handelResult(that) {
  if (that.form.resultType === 'profitRate') {
    getProfit(that);
    getProfitRate(that);
  } else {
    getProfit(that);
  }
  getTotalCostRate(that);
}
/**
 * @description 售价发生变化
 */
export function salePriceChange(that) {
  getStorageCost(that);
  getCommission(that);
  getAdType(that);
  getRefundCommission(that);
  getVATcommission(that);
  getPlatformCost(that);
  getOtherCostValue(that);
  getOthertotalCost(that);
}

export const columnsArr = [
  { id: 'picture', header: '图片', field: 'picture:imageUrl', minWidth: '70px', fixed: 'left', default: true, disabled: true },
  { id: 'asin', header: 'ASIN', field: 'slot:asin', fixed: 'left', minWidth: '130px', default: true, sortable: true, disabled: true },
  { id: 'msku', header: 'MSKU', field: 'msku', fixed: 'left', minWidth: '140px', default: true, sortable: true, copyable: true, overflowLine: 1 },
  { id: 'status', header: '状态', field: 'slot:status', minWidth: '80px', sortable: true, align: 'left', default: true },
  { id: 'title', header: '商品标题', field: 'slot:title', minWidth: '250px', overflowLine: 1 },
  { id: 'marketId', header: '店铺/国家', field: 'slot:marketId', minWidth: '120px', default: true },
  { id: 'fnsku', header: 'FNSKU', field: "fnsku", minWidth: '110px', sortable: true, overflowLine: 1, },
  { id: 'variationAsin', header: '父ASIN', field: "variationAsin", minWidth: '110px', sortable: true, default: true, overflowLine: 1 },
  { id: 'tags', header: '标签', field: 'slot:tags', minWidth: '170px', default: true },
  { id: 'asins', header: 'ASIN分析', field: 'slot:asins', minWidth: '82px', default: true },
  { id: 'sku', header: '产品名称/SKU', field: 'slot:sku', minWidth: '185px', sortable: true, sortBy: 'sku' },
  { id: 'categoryName', header: '品类', field: 'categoryName', minWidth: '120px', sortBy: 'categoryName', overflowLine: 2 },
  { id: 'brandName', header: '品牌', field: 'brandName', minWidth: '120px', overflowLine: 2 },
  { id: 'price', header: '价格', field: 'slot:price', minWidth: '140px', sortable: true, default: true },
  { id: 'b2bPrice', header: 'B2B售价', field: 'slot:businessPrice', minWidth: '140px', sortable: true, default: true },
  { id: 'fulfillment', header: '配送方式', field: 'fulfillment', minWidth: '100px',default: true },
  { id: 'openDate', header: '上架时间', field: 'openDate', minWidth: '155px', align: 'left', sortable: true },
  { id: 'chargeNameList', header: '负责人', field: 'slot:chargeNameList', minWidth: '120px', align: 'left', overflowLine:2, default: true },
  { id: 'operationStatus',default: true, header: '运营状态', field: 'slot:operationStatus', minWidth: '80px' },
  { id: 'yesterdaySaleQuantity', header: '昨日销量', field: 'yesterdaySaleQuantity', minWidth: '90px', align: 'left', default: true, sortable: true },
  { id: 'avgSaleQuantity', header: '7|14|30日均销量', field: 'avgSaleQuantity', minWidth: '150px', align: 'left', default: true, sortable: true, sortBy: 'sevenSaleQuantity' },
  { id: 'yesterdaySales', header: '昨日销售额', field: 'yesterdaySales', minWidth: '150px', align: 'left', default: true, sortable: true },
  { id: 'avgDailySales', header: '7|14|30日均销售额', field: 'avgDailySales', minWidth: '160px', align: 'left', default: true, sortable: true, sortBy: 'sevenSales' },
  { id: 'yesterdayAdsSpend', header: '昨日广告花费', field: 'yesterdayAdsSpend', minWidth: '150px', align: 'left', default: true, sortable: true },
  { id: 'yesterdayAdsSales', header: '昨日广告销售额', field: 'yesterdayAdsSales', minWidth: '150px', align: 'left', default: true, prefix: 'currencySymbol', sortable: true },
  { id: 'subCategoryRank', header: '小类排名', field: 'slot:subCategoryRank', minWidth: '185px', align: 'left', default: true, sortable: true },
  { id: 'mainCategoryRank', header: '大类排名', field: 'slot:mainCategoryRank', minWidth: '185px', align: 'left', default: true, sortable: true },
  { id: 'star', header: '星级/评分/评论数', field: 'slot:star', minWidth: '200px', align: 'left', default: true, sortable: true },
  { id: 'fbaAvailableQuantity', header: 'FBA可售', field: 'slot:fbaAvailableQuantity', minWidth: '120px', align: 'left', default: true, sortable: true, sortBy: 'fulfillableQuantity' },
  { id: 'saleableTurnover', header: 'FBA可售周转', field: 'slot:saleableTurnover', minWidth: '120px', align: 'left', default: true, sortable: true},
  { id: 'availableQuantity', header: '自营仓可用', field: 'availableQuantity', minWidth: '130px', align: 'left', default: true, sortable: true },
  { id: 'mfnQuantity', header: 'FBM库存', field: 'slot:mfnQuantity', minWidth: '130px', align: 'left', default: true, sortable: true },
  { id: 'op', header: '操作', field: 'slot:op', width: '150px', fixed: 'right', notCustomColumn: true, disabled: true },
]
export const columnsTree = [
  { id: 'mskuNum', header: ' ', field: 'mskuNum', minWidth: '70px', fixed: 'left', default: true, disabled: true, 'tree-node': true,},
  { id: 'picture', header: '图片', field: 'picture:imageUrl', minWidth: '70px', fixed: 'left', default: true, disabled: true },
  { id: 'asin', header: 'ASIN', field: 'slot:asin', fixed: 'left', minWidth: '130px', default: true, sortable: true, disabled: true },
  { id: 'msku', header: 'MSKU', field: 'msku', fixed: 'left', minWidth: '140px', default: true, sortable: true, copyable: true, overflowLine: 1 },
  { id: 'status', header: '状态', field: 'slot:status', minWidth: '80px', sortable: true, align: 'left', default: true },
  { id: 'title', header: '商品标题', field: 'slot:title', minWidth: '250px', overflowLine: 1 },
  { id: 'marketId', header: '店铺/国家', field: 'slot:marketId', minWidth: '120px', default: true },
  { id: 'fnsku', header: 'FNSKU', field: "fnsku", minWidth: '110px', sortable: true, overflowLine: 1, },
  { id: 'tags', header: '标签', field: 'slot:tags', minWidth: '170px', default: true, overflowLine: 1 },
  { id: 'asins', header: 'ASIN分析', field: 'slot:asins', minWidth: '82px', default: true },
  { id: 'sku', header: '产品名称/SKU', field: 'slot:sku', minWidth: '185px', sortable: true, sortBy: 'sku' },
  { id: 'categoryName', header: '品类', field: 'categoryName', minWidth: '120px', sortBy: 'categoryName', overflowLine: 2 },
  { id: 'brandName', header: '品牌', field: 'brandName', minWidth: '120px', overflowLine: 2 },
  { id: 'price', header: '价格', field: 'slot:price', minWidth: '140px', sortable: true, default: true },
  { id: 'b2bPrice', header: 'B2B售价', field: 'slot:businessPrice', minWidth: '140px', sortable: true, default: true },
  { id: 'fulfillment', header: '配送方式', field: 'fulfillment', minWidth: '100px',default: true },
  { id: 'openDate', header: '上架时间', field: 'openDate', minWidth: '155px', align: 'left', sortable: true },
  { id: 'chargeNameList', header: '负责人', field: 'slot:chargeNameList', minWidth: '120px', align: 'left', overflowLine:2, default: true },
  { id: 'operationStatus',default: true, header: '运营状态', field: 'slot:operationStatus', minWidth: '80px' },
  { id: 'yesterdaySaleQuantity', header: '昨日销量', field: 'yesterdaySaleQuantity', minWidth: '90px', align: 'left', default: true, sortable: true },
  { id: 'avgSaleQuantity', header: '7|14|30日均销量', field: 'avgSaleQuantity', minWidth: '150px', align: 'left', default: true, sortable: true, sortBy: 'sevenSaleQuantity' },
  { id: 'yesterdaySales', header: '昨日销售额', field: 'yesterdaySales', minWidth: '150px', align: 'left', default: true, sortable: true },
  { id: 'avgDailySales', header: '7|14|30日均销售额', field: 'avgDailySales', minWidth: '160px', align: 'left', default: true, sortable: true, sortBy: 'sevenSales' },
  { id: 'yesterdayAdsSpend', header: '昨日广告花费', field: 'yesterdayAdsSpend', minWidth: '150px', align: 'left', default: true, sortable: true },
  { id: 'yesterdayAdsSales', header: '昨日广告销售额', field: 'yesterdayAdsSales', minWidth: '150px', align: 'left', default: true, prefix: 'currencySymbol', sortable: true },
  { id: 'subCategoryRank', header: '小类排名', field: 'slot:subCategoryRank', minWidth: '185px', align: 'left', default: true, sortable: true },
  { id: 'mainCategoryRank', header: '大类排名', field: 'slot:mainCategoryRank', minWidth: '185px', align: 'left', default: true, sortable: true },
  { id: 'star', header: '星级/评分/评论数', field: 'slot:star', minWidth: '200px', align: 'left', default: true, sortable: true },
  { id: 'fbaAvailableQuantity', header: 'FBA可售', field: 'slot:fbaAvailableQuantity', minWidth: '120px', align: 'left', default: true, sortable: true, sortBy: 'fulfillableQuantity' },
  { id: 'saleableTurnover', header: 'FBA可售周转', field: 'slot:saleableTurnover', minWidth: '120px', align: 'left', default: true, sortable: true},
  { id: 'availableQuantity', header: '自营仓可用', field: 'availableQuantity', minWidth: '130px', align: 'left', default: true, sortable: true },
  { id: 'mfnQuantity', header: 'FBM库存', field: 'slot:mfnQuantity', minWidth: '130px', align: 'left', default: true, sortable: true },
  { id: 'op', header: '操作', field: 'slot:op', width: '150px', fixed: 'right', notCustomColumn: true, disabled: true },
]

export const pageConfigArr = [20,50,100,200]
export const pageConfigTree = [20,50]
